import PropTypes from 'prop-types';
import { Grid, Link } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
// import { Link } from 'react-router-dom'
import { useCallback } from 'react';
import moment from 'moment';

CustomMetaData.propTypes = {
  item: PropTypes.object,
  currentLang: PropTypes.object,
  translate: PropTypes.func,
  theme: PropTypes.object,
  itterable: PropTypes.bool,
  categories: PropTypes.array,
  tags: PropTypes.array,
  isCS: PropTypes.bool,
};

export default function CustomMetaData({ itterable, item, currentLang, translate, theme, categories, tags, isCS }) {
  const [params] = useSearchParams();
  const fromPage = params.get('fromPage');

  const onlyWithImage = JSON.parse(decodeURIComponent(params.get('url')))?.filter
    ? JSON.parse(JSON.parse(decodeURIComponent(params.get('url'))).filter).onlyWithImage
    : true;

  const onlyUnBlackened = JSON.parse(decodeURIComponent(params.get('url')))?.filter
    ? JSON.parse(JSON.parse(decodeURIComponent(params.get('url'))).filter).onlyUnBlackened
    : false;
  // eslint-disable-next-line consistent-return
  const getRouteWithParams = (name, value) => {
    const pathCS = window.location.pathname.includes('en/')
      ? `/en${translate('urls.sheets')}`
      : translate('urls.sheets');
    const pathKO = window.location.pathname.includes('en/') ? `/en${translate('urls.co')}` : translate('urls.co');
    if (!isCS) {
      switch (name) {
        case 'Category': {
          const parentKeys = categories.filter((item) => item.name === value).map((item) => item.categoryKey);

          const parentCategory = categories.find((item) => parentKeys.includes(item?.categoryKey));

          if (parentCategory) {
            const data = { onlyWithImage, categoryKeys: [parentCategory?.categoryKey || ''] };
            return `${pathKO}?filter=${JSON.stringify(data)}`;
          }
          return '';
        }
        case 'Subcategory': {
          const parentKeys = categories
            .filter((item) => item.name === value)
            .map((item) => item.categoryKey.length > 3 && item.categoryKey);
          const subcategory = categories.find((item) => parentKeys.includes(item?.categoryKey));
          if (subcategory) {
            const data = { onlyWithImage, categoryKeys: [subcategory?.categoryKey] };
            return `${pathKO}?filter=${JSON.stringify(data)}`;
          }
          return '';
        }
        case 'Author': {
          const key = tags.find((cat) => cat.name === value)?.tagKey;
          if (key) {
            const data = { onlyWithImage, tagKeys: [key] };
            return `${pathKO}?filter=${JSON.stringify(data)}`;
          }
          return '';
        }
        case 'Owner': {
          const key = tags.find((cat) => cat.name === value)?.tagKey;
          if (key) {
            const data = { onlyWithImage, tagKeys: [key] };
            return `${pathKO}?filter=${JSON.stringify(data)}`;
          }
          return '';
          // return `${pathKO}?onlyWithImage=${onlyWithImage}`;
        }
        default:
          return `/`;
      }
    } else if (isCS) {
      switch (name) {
        case 'Date': {
          const key = tags.find((cat) => cat.name === value)?.tagKey;
          const data = { onlyUnBlackened, tagKeys: [key] };
          return `${pathCS}?filter=${JSON.stringify(data)}`;
          // return null;
        }
        case 'County': {
          const parentKeys = categories.filter((item) => item.name === value).map((item) => item.parentKey);
          const district = categories.find((item) => parentKeys.includes(item.categoryKey));
          const district2 = categories.find((item) => !parentKeys.includes(item.categoryKey));
          const params = {
            onlyUnBlackened,
            categoryKeys:
              district?.categoryKey.length > 2
                ? [district.categoryKey, district2.categoryKey]
                : [district2.categoryKey],
          };
          return `${pathCS}?filter=${JSON.stringify(params)}`;
        }
        case 'Municipality': {
          const parentKeys = categories.filter((item) => item.name === value).map((item) => item.parentKey);

          const districts = parentKeys.filter((item) => item.length > 2);
          const city = categories.find((item) => !parentKeys.includes(item.categoryKey));
          const params = {
            // cat: 'city',
            // key: city.categoryKey,
            // param: 'city',
            // name: city.name,
            onlyUnBlackened,
            categoryKeys: [...districts, city.categoryKey],
          };
          return `${pathCS}?filter=${JSON.stringify(params)}`;
        }
        default:
          return `/`;
      }
    }
  };

  const correctMetadataCO = useCallback(
    (item) => {
      const { name, values } = item;
      if (name === 'Category' || name === 'Subcategory' || name === 'Author' || name === 'Owner') {
        return values.map((value, i) =>
          getRouteWithParams(item.name, value) === '' || getRouteWithParams(item.name, value) === '/' ? (
            <span key={i} className="dsgLink">
              {`${value}${i !== values.length - 1 ? ', ' : ''}`}
            </span>
          ) : (
            <Link
              key={i}
              to={`${getRouteWithParams(item.name, value)}`}
              component={RouterLink}
              sx={{ color: 'inherit', fontWeight: 'bold', textDecoration: 'underline !important' }}
            >
              {`${value}${i !== values.length - 1 ? ', ' : ''}`}
            </Link>
          )
        );
      }
      if (name === 'URL') {
        return values.map((value, i) => (
          <Link
            key={i}
            href={value}
            className="dsgLink"
            target={'_blank'}
            sx={{ color: 'inherit', fontWeight: 'bold', textDecoration: 'underline !important' }}
          >
            {`${value}${i !== values.length - 1 ? ', ' : ''}`}
          </Link>
        ));
      }
      return values.map((values, i) => (
        <span key={i} className="dsgLink">
          {`${values?.values || values}${i !== item.values.length - 1 ? ', ' : ''}`}
        </span>
      ));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [item, isCS]
  );
  const correctMetadataCS = useCallback(
    (item) => {
      const { name } = item;
      let { values } = item;
      if (name === 'Date') {
        values = values.map((v) => {
          if (v.length > 4) {
            return moment(v).format('yyyy');
            // return v.substring(0, 4);
          }
          return v;
        });
      }
      const isLink = tags.find((item) => values.includes(item.name));
      if (name === 'Date') {
        return values.map((value, i) =>
          isCS && !!isLink ? (
            <Link
              key={i}
              to={`${getRouteWithParams(item.name, value)}`}
              component={RouterLink}
              sx={{ color: 'inherit', fontWeight: 'bold', textDecoration: 'underline !important' }}
            >
              {`${value}${i !== values.length - 1 ? ', ' : ''}`}
            </Link>
          ) : (
            <span key={i} className="dsgLink">{`${value}${i !== values.length - 1 ? ', ' : ''}`}</span>
          )
        );
      }
      if (name === 'County' || name === 'Municipality') {
        return values.map((value, i) => {
          const itemsCategory = categories.findIndex((cat) => cat.name === value);
          if (itemsCategory !== -1) {
            return (
              <Link
                key={i}
                to={`${getRouteWithParams(item.name, value /* , categories[itemsCategory] */)}`}
                component={RouterLink}
                sx={{ color: 'inherit', fontWeight: 'bold', textDecoration: 'underline !important' }}
              >
                {`${value}${i !== values.length - 1 ? ', ' : ''}`}
              </Link>
            );
          }
          return (
            <span key={i} className="dsgLink">
              {`${value?.value || value}${i !== 0 && i !== item.values.length - 1 ? ', ' : ''}`}
            </span>
          );
        });
      }
      return values.map((values, i) => (
        <span key={i} className="dsgLink">
          {`${values?.values || values}${i !== item.values.length - 1 ? ', ' : ''}`}
        </span>
      ));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [item, isCS]
  );

  const metadata = useCallback(
    (item) => (fromPage === 'ko' || fromPage === 'video' || !isCS ? correctMetadataCO(item) : correctMetadataCS(item)),
    [correctMetadataCO, correctMetadataCS, fromPage, isCS]
  );

  return (
    <Grid container spacing={1} sx={{ width: '100% !important' }}>
      <Grid
        xs={12}
        md={4}
        item
        sx={{ textAlign: 'left', [theme.breakpoints.up('md')]: { textAlign: 'right' } }}
        id="noprintable"
        className="noprintable"
      >
        {currentLang.value === 'en'
          ? item.name
          : translate(
              item.name
                ? `objects.metadata.${item.name}`
                : `objects.metadata.${!item.name.includes(':') ? item.name : item.name.split(':').join('_')}`
            )}
        :
      </Grid>
      <Grid xs={12} md={8} item id="noprintable" className="noprintable">
        {itterable ? metadata(item) : item.text || item.values}
      </Grid>

      {/* DIFFERENT VERSION FOR PRINT */}
      <Grid
        xs={12}
        md={3}
        item
        sx={{
          textAlign: 'left',
          [theme.breakpoints.up('md')]: { textAlign: 'right' },
          visibility: 'hidden',
          display: 'none',
        }}
        id="printable"
      >
        {currentLang.value === 'en'
          ? item.name
          : translate(
              item.name
                ? `objects.metadata.${item.name}`
                : `objects.metadata.${!item.name.includes(':') ? item.name : item.name.split(':').join('_')}`
            )}
        :
      </Grid>
      <Grid xs={12} md item sx={{ visibility: 'hidden', display: 'none' }} id="printable">
        {itterable ? metadata(item) : item.text || item.values}
      </Grid>
    </Grid>
  );
}
